"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { submitting: false };
        GState.bind(this, [
            'tenant',
            'auth'
        ]);
        this.hasFormData = this.state.auth && !!this.state.auth.formdata;
        fhandler.bind(this, this.hasFormData && this.state.auth.formdata || {});
    },
    onMount: async function () {
        let location;
        try {
            location = await getClientLocation();
        } catch (error) {
            console.log('Get Client Location Error: ', error);
            throw new Error('We are having trouble getting your location. Try again');
        }
        fhandler.set('country', location);
        UISocket.emit('APP::GET_SSOTOKEN', {
            authType: 'signup',
            device: window.Device,
            userAgent: window.UserAgent,
            location
        }, token => this.state.SSToken = token);
    },
    onSubmit: async function () {
        if (this.state.submitting)
            return;
        if (!this.state.form.email)
            return this.state.formError.email;
        const Form = this.state.form;
        Form.device = window.Device;
        if (!Form.country)
            return navigate('/signin');
        this.state.submitting = true;
        try {
            const {error, message, token} = await AuthRequest('/reset-account', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'info' : 'success');
            if (error)
                return;
            !error && fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error, 'warning');
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Auth/ResetAccount.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    TenantLogo_template = require("../../../components/TenantLogo/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    TenantLogo_tag = marko_loadTag(TenantLogo_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    AuthLayout_template = require("../../components/AuthLayout/index.marko"),
    AuthLayout_tag = marko_loadTag(AuthLayout_template),
    marko_attrs0 = {
        "class": "card-header w-100 pb-0"
      },
    marko_attrs1 = {
        "class": "card-body"
      },
    marko_attrs2 = {
        "class": "text-center"
      },
    marko_attrs3 = {
        "class": "font-medium-2"
      },
    marko_attrs4 = {
        href: "/"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("53a332"),
    marko_node0 = marko_createElement("br", null, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "form-group"
      },
    marko_attrs6 = {
        "class": "form-group"
      },
    marko_attrs7 = {
        "class": "py-1"
      },
    marko_attrs8 = {
        "class": "col-3"
      },
    marko_attrs9 = {
        "class": "col text-right"
      },
    marko_attrs10 = {
        "class": "font-medium-5"
      };

const fhandler = new FormHandler({ key: 'reset-account-form' });

function render(input, out, __component, component, state) {
  var data = input;

  AuthLayout_tag({
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        Row_tag({
            class: "d-flex align-items-center",
            renderBody: function(out) {
              out.be("div", marko_attrs8, "3", component);

              TenantLogo_tag({
                  style: "width:40px"
                }, out, __component, "4");

              out.ee();

              out.be("div", marko_attrs9, "5", component);

              out.be("h4", marko_attrs10, "6", component);

              Locale_tag({
                  text: state.tenant.name
                }, out, __component, "7");

              out.ee();

              out.ee();
            }
          }, out, __component, "2");

        out.ee();

        out.be("div", marko_attrs1, "8", component);

        out.be("form", null, "@reset-account-form", component);

        out.be("div", marko_attrs2, "9", component);

        Image_tag({
            alt: "Image",
            src: "/images/illustration/forgotten-password.jpg",
            class: "img-fluid w-50"
          }, out, __component, "10");

        out.ee();

        FormAlert_tag({
            alert: state.alert
          }, out, __component, "11");

        out.be("h5", null, "12", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Welcome back");
            }
          }, out, __component, "13");

        out.t(" ");

        Locale_tag({
            text: state.form.first_name
          }, out, __component, "14");

        out.ee();

        out.be("p", marko_attrs3, "15", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Your new account is ready for you. Follow the next few steps to continue.");
            }
          }, out, __component, "16");

        out.t(" ");

        out.be("a", marko_attrs4, "17", component);

        Locale_tag({
            text: "Learn more"
          }, out, __component, "18");

        out.ee();

        out.ee();

        out.n(marko_node0, component);

        out.e("div", marko_attrs5, "20", component, 1)
          .e("input", {
              "class": "form-control form-control-xl",
              type: "email",
              required: true,
              name: "email",
              value: state.form.email,
              validate: fhandler.define("email"),
              placeholder: Locale("Account Email Address")
            }, "21", component, 0, 0, {
              onchange: __component.d("change", "__onChange", false)
            });

        out.e("div", marko_attrs6, "22", component, 1)
          .e("input", {
              "class": "form-control form-control-xl",
              type: "password",
              required: true,
              name: "password",
              value: state.form.password,
              placeholder: Locale("Enter new password")
            }, "23", component, 0, 0, {
              onchange: __component.d("change", "__onChange", false)
            });

        out.be("div", marko_attrs7, "24", component);

        out.be("button", {
            type: "submit",
            disabled: (!state.form.password) || state.submitting,
            "class": "btn btn-primary btn-xl text-left w-100"
          }, "25", component, null, 0, {
            onclick: __component.d("click", "onSubmit", false)
          });

        if (state.submitting) {
          Preloader_tag({
              class: "float-right font-medium-5",
              active: true
            }, out, __component, "26");
        } else {
          Bx_tag({
              type: "right-arrow-alt",
              class: "font-large-1 float-right white-text"
            }, out, __component, "27");
        }

        Locale_tag({
            text: "Continue"
          }, out, __component, "28");

        out.ee();

        out.ee();

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
